import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const CodeIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"code"} ref={ref}/>
});

CodeIcon.displayName = "CodeIcon";
